let isPageLoad = true;

function updateInput(selector, attributes = {}, clearValue = false) {
    const $el = $(selector);
    if($el.length === 0) {
        console.warn(`Element ${selector} not found.`);
        return;
    }

    Object.entries(attributes).forEach(([key, value]) => {
        if(value !== null && value !== undefined) {
            $el.attr(key, value);
        }
    });
    if(typeof window.donotClearTheFields !== 'undefined' && window.donotClearTheFields === true) {
        return;
    }

    if(clearValue && !isPageLoad) $el.val('');
}

function changeAlternateCountryHandler(e) {
    let selectedValue;
    try {
        e.preventDefault();
        const selectedOption = this.options[this.selectedIndex];
        if(!selectedOption) {
            console.warn('No option selected.');
            return;
        }
        selectedValue = selectedOption.value || '';
        const addressInvalidCharRegex = selectedOption.getAttribute('data-address-invalid-char-regex') || '';
        const addressRequiredMessage = selectedOption.getAttribute('data-address-required-message') || '';
        const addressValidationMessage = selectedOption.getAttribute('data-address-validation-message') || '';
        const cityRequiredMessage = selectedOption.getAttribute('data-city-required-message') || '';
        const cityValidationMessage = selectedOption.getAttribute('data-city-validation-message') || '';
        const cityRegex = selectedOption.getAttribute('data-city-regex') || '';
        const postalCodeRegex = selectedOption.getAttribute('data-postal-code-regex') || '';
        const postalCodeRequiredMessage = selectedOption.getAttribute('data-postal-code-required-message') || '';
        const phoneRegex = selectedOption.getAttribute('data-phone-regex') || '';

        updateInput('#countryCode', { value: selectedValue });
        updateInput('#selectedState', { value: selectedValue });
        if($('#IsShippingPage').length === 0) {
            updateInput('#selectedCountry', { value: selectedValue });
        }
        updateInput('#address1Input', {
            'data-invalidchars': addressInvalidCharRegex,
            'data-msg-invalidchars': addressValidationMessage,
            'data-msg-required': addressRequiredMessage
        }, true);
        updateInput('#address2Input', {
            'data-invalidchars': addressInvalidCharRegex,
            'data-msg-invalidchars': addressValidationMessage,
            'data-msg-required': addressRequiredMessage
        }, true);

        updateInput('#cityInput', {
            'data-invalidchars': cityRegex,
            'data-msg-invalidchars': cityValidationMessage,
            'data-msg-required': cityRequiredMessage
        }, true);

        updateInput('#zipCodeInput', {
            'data-msg-required': postalCodeRequiredMessage,
            'pattern': postalCodeRegex
        }, true);

        if($('#IsShippingPage').length > 0 && $('#IsAnyEnrollmentFlowType').length === 0 && $('#ignore-phone-number-regex-update').length === 0) {
            updateInput('#phone', {
                'pattern': phoneRegex
            }, true);
        }
    } catch (error) {
        console.error('Error in changeAlternateCountryHandler:', error);
    }

    if(!isPageLoad) {
        populateAddressFields(selectedValue);
    }
}

function populateAddressFields(countryCode) {
    if(typeof window.donotClearTheFields !== 'undefined' && window.donotClearTheFields === true) {
        window.donotClearTheFields = undefined;
        return;
    }

    if(!countryCode) return;
    try {
        const rawJson = $('#hidden-alternate-country-test-members').attr('data-value');
        if(!rawJson) return;
        const data = JSON.parse(rawJson);
        const address = data[countryCode];
        if(!address) return;
        $('#address1Input').val(address.AddressLine || '').trigger('input').trigger('keyup');
        $('#cityInput').val(address.City || '').trigger('input').trigger('keyup');
        $('#zipCodeInput').val(address.Zip || '').trigger('input').trigger('keyup').trigger('blur');
    } catch (error) {
        console.error('Error populating address fields:', error);
    }
}

function selectSavedAddress() {
    try {
        const $selectedIndexInput = $('#selected-address-index');
        if($selectedIndexInput.length === 0) return;

        const indexValue = parseInt($selectedIndexInput.val(), 10);
        if(isNaN(indexValue) || indexValue < 0) return;

        const $savedAddresses = $('#savedAddresses');
        if($savedAddresses.length === 0 || $savedAddresses.find('option').length === 0) return;
        if(indexValue >= $savedAddresses.find('option').length) return;

        const $optionToSelect = $savedAddresses.find(`option[value='${indexValue}']`);
        if($optionToSelect.length === 0) return;
        $savedAddresses.val(indexValue).trigger('change');
    } catch (error) {
        console.error('Error selecting saved address:', error);
    }
}

$(function () {
    $('#alternateCountryDd').on('change', changeAlternateCountryHandler);
    const selectedDropdownVal = $('#alternateCountryDd').val();
    const catalogCountryCode = $('#CatalogCountryCode').val();
    if(selectedDropdownVal !== catalogCountryCode) {
        $('#alternateCountryDd').trigger('change');
    }

    isPageLoad = false;
    if($('#selected-phone-number-regex').length && $('#phone').length) {
        const phoneRegex = $('#selected-phone-number-regex').data('value');
        $('#phone').attr('pattern', phoneRegex);
    }
    selectSavedAddress();
});
